export const IMPORT_DATA_SUCCESS = 'IMPORT_DATA_SUCCESS';
export const IMPORT_DATA_FAILURE = 'IMPORT_DATA_FAILURE';

export const PUSH_DATA = 'PUSH_DATA';
